import { styled } from '@mui/material';

export const Wrap = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	gap: '16px',
	flex: 1,
});
